import React from 'react';
import classnames from 'classnames';
import LinkJump from '@gp/components/LinkJump';
import { getProjectDetailsPagePath, goToProjectDetailsPageByPath } from '@gp/utils/project';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { PROJECT_DETAIL_STORAGE_KEY } from '@gp/constants/storageKeys';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportUpdatesOfTheWeekChangeVO } from '@gp/types/dpsReport/v3';

import './index.scss';

interface IUpdatesProps extends IBaseProps {
  projectId?: string;
  projectName?: string;
  list?: IDPSReportUpdatesOfTheWeekChangeVO[] | null;
}

const Updates: React.FC<IUpdatesProps> = (props) => {
  const { style, className, projectId, projectName, list } = props;
  const isNoData = !Array.isArray(list) || !list.length;

  return (
    <div style={style} className={classnames('dbg-dps-report-updates-of-week-updates', className)}>
      {!isNoData && (
        <ul className="dbg-dps-report-updates-of-week-updates__list">
          {list.map((item) => {
            const { change_type: changeType, domain_id: domainId, content } = item || {};
            const isUpdatesInfoChange = changeType === 3 && !!domainId && Array.isArray(content) && content.length > 0;
            const url = getProjectDetailsPagePath({
              id: projectId as any,
              name: projectName,
              tab: 'projectUpdate',
            });
            const searchParamsIndex = url.lastIndexOf('?');
            const searchParams = new URLSearchParams(url.substring(searchParamsIndex + 1));
            searchParams.append('from', 'dpsReport');
            searchParams.append('updateId', domainId);
            const linkUrl = `${url.substring(0, searchParamsIndex)}?${searchParams.toString()}`;
            if (!content?.length) return null;
            return (
              <li key={changeType} className="dbg-dps-report-updates-of-week-updates__item">
                {isUpdatesInfoChange || (
                  <span
                    className="dbg-dps-report-updates-of-week-updates__content gp-word-break-word gp-inital-list-style dbg-edit-text dbg-rich-text-editor-content"
                    dangerouslySetInnerHTML={{ __html: content?.join(' ') }}
                  />
                )}
                {isUpdatesInfoChange && (
                  <LinkJump
                    isStopPropagation
                    isPreventDefault
                    url={linkUrl}
                    onClick={() => {
                      storage.setSessionStorageItem(
                        PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_UPDATE_ID_STORAGE_KEY,
                        domainId,
                      );
                      goToProjectDetailsPageByPath(url);
                    }}
                  >
                    <span
                      className="dbg-text-highlight dbg-cursor-pointer dbg-dps-report-updates-of-week-updates__content"
                      dangerouslySetInnerHTML={{ __html: content?.join(' ') }}
                    />
                  </LinkJump>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default Updates;
